import { ScanFace, Phone } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PHONE_TEL, PHONE_DISPLAY } from "../data/content";

export const News = () => (
  <section id="novita" className="bg-cream py-24 md:py-36" data-testid="news-section">
    <div className="container-x">
      <SectionHeading
        id="news"
        eyebrow="Novità e Promozioni"
        title={<>Le ultime <em className="font-normal italic text-sage">novità</em> in centro.</>}
      />
      <Reveal delay={0.15} className="mt-16">
        <div className="relative overflow-hidden rounded-[2rem] bg-beige grain" data-testid="news-skin-analyzer">
          <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-white/60 blur-3xl" />
          <div className="relative grid gap-10 p-8 md:grid-cols-12 md:p-14 lg:items-center">
            <div className="md:col-span-3 flex md:justify-center">
              <span className="relative flex h-28 w-28 items-center justify-center rounded-full bg-white text-sage shadow-[0_20px_40px_-20px_rgba(59,52,43,0.35)] md:h-36 md:w-36">
                <span className="absolute inset-0 rounded-full border border-sage/30 animate-pulseRing" />
                <ScanFace className="h-12 w-12 md:h-16 md:w-16" strokeWidth={1.4} />
              </span>
            </div>
            <div className="md:col-span-9">
              <h3 className="font-serif text-3xl leading-tight text-ink sm:text-4xl lg:text-5xl">Skin Analyzer</h3>
              <p className="mt-4 max-w-2xl text-base leading-relaxed text-muted md:text-lg">
                Analizziamo la pelle del viso per vedere l'età biologica esternamente ed internamente. Costo: <strong className="text-ink">40€</strong>
              </p>
              <a href={PHONE_TEL} className="btn-sage mt-8" data-testid="news-call-btn">
                <Phone className="h-4 w-4" /> Chiama per informazioni · {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
